// extracted by mini-css-extract-plugin
export default {"root":"workspace-selector-input_root__ZrNB5","input":"workspace-selector-input_input__PoDu+","error":"workspace-selector-input_error__Rq9oE"};